module.exports = __webpack_public_path__ + "static/media/favicon2.e9807743.png";